<template>
<ExtLayout v-bind="pageBind">
  <small slot="title-other" class="title-other">
    <span v-if="canUse">该服务已开通</span>
    <span v-else class="overtime">升级至个人中心版后自动开通</span>
  </small>

  <div slot="top-buy" class="top-buy">
    <zt-button type="primary" width="140px" @click="handleBuyClick" v-if="canUse === false">立即购买</zt-button>
  </div>

  <zt-title>基础设置</zt-title>
  <el-tabs>
    <el-tab-pane label="饿了么">
      <div slot="label">饿了么<span style="color: #FE7A42;" v-if="isTaobaoAuthEnd">（未激活）</span></div>
      <el-alert type="error" v-if="isTaobaoAuthEnd && canUse">
        <app-link to="/pid-manage">请前往 ”联盟设置“ 中配置“淘宝联盟”后使用。去配置>></app-link>
      </el-alert>
      <el-form label-width="140px" label-position="left">
        <el-form-item label="开启状态:">
          <el-switch :disabled="isTaobaoAuthEnd || !canUse" :value="ele_waimai_open === 1" @input="handleWaiMaiSet('ele_waimai_open')" />
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="美团">
      <div slot="label">美团<span style="color: #FE7A42;" v-if="isDuomaiAuthEnd">（未激活）</span></div>
      <el-alert type="error" v-if="isDuomaiAuthEnd && canUse">
        <app-link to="/pid-manage">请前往 ”联盟设置“ 中配置“多麦联盟”后使用。去配置>></app-link>
      </el-alert>
      <el-form label-width="140px" label-position="left">
        <el-form-item label="开启状态:">
          <el-switch :disabled="isDuomaiAuthEnd || !canUse" :value="meituan_waimai_open === 1" @input="handleWaiMaiSet('meituan_waimai_open')" />
        </el-form-item>
        <el-form-item label="推广位ID:">
          <el-input style="width: 240px" v-model="duomai_site_id" :disabled="!canUse"></el-input>
        </el-form-item>
        <el-form-item label="计划ID:">
          <el-input style="width: 240px" v-model="duomai_plan_id" :disabled="!canUse"></el-input>
        </el-form-item>
        <el-form-item>
          <zt-button type="primary" @click="handleSaveDuomai" :loading="duomaiLoading" :disabled="!canUse">保存</zt-button>
        </el-form-item>
      </el-form>

    </el-tab-pane>
    <!-- <el-tab-pane label="肯德基">

      </el-tab-pane> -->
  </el-tabs>

  <zt-title>订单统计</zt-title>

  <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :pickerOptions="pickerOptions" class="mb16" :disabled="!canUse" />

  <el-table :data="report">
    <el-table-column label="统计时间" width="100px" prop="date"></el-table-column>

    <el-table-column label="饿了么" align="center">
      <el-table-column label="订单数" prop="ele.count"></el-table-column>
      <el-table-column label="结算佣金" prop="ele.sum">
        <template slot-scope="{row}">{{ row.ele ? ('¥'+row.ele.sum) : '' }}</template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="美团外卖" align="center">
      <el-table-column label="订单数" prop="meituan.count"></el-table-column>
      <el-table-column label="结算佣金" prop="meituan.sum">
        <template slot-scope="{row}">{{ row.meituan ? ('¥'+row.meituan.sum) : '' }}</template>
      </el-table-column>
    </el-table-column>

  </el-table>
</ExtLayout>
</template>

<script>
import env from '@/utils/env';
import ExtLayout from '../components/ExtLayout';
import statisticalTable from '../mixins/statisticalTable';
import taoke_duomai_meituan_set from '@/api/taoke_duomai_meituan_set'
import taoke_duomai_meituan_info from '@/api/taoke_duomai_meituan_info'
import taoke_waimai_set from '@/api/taoke_waimai_set'
import taoke_duomai_meituan_report from '@/api/taoke_duomai_meituan_report'
import taoke_ele_report from '@/api/taoke_ele_report'
import { formatDate } from '@/utils/date'

function date() {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  return date
}

export default {
  name: 'ExtensionFood',
  components: {
    ExtLayout,
  },
  mixins: [statisticalTable],

  data: () => ({
    duomai_site_id: '', // 多麦推广位ID
    duomai_plan_id: '', // 多麦美团推广计划ID
    duomaiLoading: false,

    BASE_URL: env.DEV ? '' : process.env.BASE_URL,

    // 购买提示弹框
    buyVisible: false,

    report: [],

    date: [
      date().setMonth(date().getMonth() - 1), // 一个月之前
      date(),
    ],

    pickerOptions: {
      shortcuts: [
        {
          text: '最近一个月',
          onClick(picker) {
            const end = date()
            const start = date().setMonth(end.getMonth() - 1)
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近两个月',
          onClick(picker) {
            const end = date()
            const start = date().setMonth(end.getMonth() - 2)
            picker.$emit('pick', [start, end]);
          },
        },
      ],
      disabledDate: ((start, end) => (time) => {
        return time > end || time < start
      })(date().setMonth(new Date().getMonth() - 2), date()),
    },
  }),

  computed: {

    vip: (vm) => vm.$store.getters.user_vip,
    canUse: (vm) => vm.vip > 1, // 是否可以使用该插件

    // 淘宝联盟授权是否过期
    isTaobaoAuthEnd: (vm) => {
      const taobao_expires_at = vm.$store.state.user.info.taobao_expires_at || 0
      return parseInt(Date.now() / 1000) > taobao_expires_at
    },

    // 多麦联盟授权是否过期(是否设置，多麦没有过期)
    isDuomaiAuthEnd: (vm) => {
      const { duomai_union_id, duomai_union_key } = vm.$store.getters.user_info
      return !(duomai_union_id && duomai_union_key)
    },

    // 饿了么外卖开关
    ele_waimai_open: (vm) => vm.$store.getters.user_info.ele_waimai_open,
    // 美团外卖开关
    meituan_waimai_open: (vm) => vm.$store.getters.user_info.meituan_waimai_open,

    // 插件信息
    pageBind: (vm) => ({
      borderColor: '#FFDD9D',
      title: '外卖优惠',
      icon: vm.BASE_URL + '/images/ext18.png',
      desc: '顿顿省一点',
    }),

  },

  watch: {
    date: {
      immediate: true,
      handler() {
        // 获取统计
        this.loadReport()
      },
    },
  },

  methods: {

    // 外卖开关
    async handleWaiMaiSet(field) {
      const status = this[field] - 0
      const submitFiledKey = field.replace('_waimai', '') // 'ele_waimai_open' -> 'meituan_open'
      const { data } =  await taoke_waimai_set({ [submitFiledKey]: status ? 0 : 1 })
    
      if (data.error_code !== 0) {
        this.$message.error(data.error_message)
      } else {
        this.$message.success('设置成功')
      }
      await this.$store.dispatch('GetUserInfo')
    },

    // 保存多麦的推广位id 和 计划id
    async handleSaveDuomai() {
      this.duomaiLoading = true
      const { data } = await taoke_duomai_meituan_set({
        duomai_site_id: this.duomai_site_id,
        duomai_plan_id: this.duomai_plan_id,
      })
      this.duomaiLoading = false

      if (data.error_code !== 0) {
        this.$message.error(data.error_message)
      } else {
        this.$message.success('设置成功')
      }
    },

    // 统计数据
    async loadReport() {
      if (this.canUse === false) return

      let [date_from, date_to] = this.date
      date_from = formatDate(date_from, 'YYYY-MM-DD')
      date_to = formatDate(date_to, 'YYYY-MM-DD')

      let [ meituan, ele ] = await Promise.all([
        taoke_duomai_meituan_report({ date_from, date_to }),
        taoke_ele_report({ date_from, date_to }),
      ])
      meituan = meituan.data.report || []
      ele = ele.data.report || []

      const dataMap = {}

      meituan.forEach((item) => {
        if (!dataMap[item.date]) {
          dataMap[item.date] = {date: item.date}
        }
        dataMap[item.date].meituan = item
      })

      ele.forEach((item) => {
        if (!dataMap[item.date]) {
          dataMap[item.date] = {date: item.date}
        }
        dataMap[item.date].ele = item
      })

      this.report = Object.keys(dataMap)
        .map((key) => dataMap[key])
        .sort((a, b) => new Date(b.date) - new Date(a.date))
    },

    handleBuyClick() {
      this.$confirm('升级到个人中心版即可开启该功能', '提示', {
        confirmButtonText: '立即去升级',
      }).then(() => {
        this.$router.push('/cms-website/upgrade')
      }).catch(() => {})
    },
  },

  mounted() {
    // 获取美团信息
    taoke_duomai_meituan_info().then(({ data }) => {
      if (data.info) {
        this.duomai_plan_id = data.info.duomai_plan_id
        this.duomai_site_id = data.info.duomai_site_id
      }
    })

  },
}
</script>

<style lang="scss" scoped>

</style>
